export const getLearningHistory = (payload?: any) => ({
    type: "@saga/GET_LEARNING_HISTORY",
    payload
});

